export const PSP_LIST = {
  TempoWallet: {
    id: '502ff70b-47df-44cb-bf6e-2f0993e72bfd',
  },
  FPF: {
    id: '5d1c239d-94eb-4efb-b06c-1c91c5e61a6b',
  },
};
